import * as actions from '../actions/solicitorImages';
import * as ActionTypes from '../actions/index';
import xs from 'xstream';
import BASE_URL from './variables';
import flattenConcurrently from 'xstream/extra/flattenConcurrently';
import {isAgent} from "../helpers/functions";


export function getImagefileUrl(sources){
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.GET_IMAGE_FILE)
        .map(action => ({
            url: BASE_URL + 'images/' + action.payload,
            category: 'getImagefileUrl',
            method: 'GET'
        }));

    let httpResponse$ = sources.HTTP
        .select('getImagefileUrl')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .compose(flattenConcurrently)
        .filter(response => response.status < 400)
        .map(response => actions.receiveImageFile(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function getImagesAfterloggingIn(sources) {
    let httpResponse$ = sources.HTTP
        .select('users')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .filter(response => isAgent(JSON.parse(response.text).roles))
        .map(response => actions.getSolicitorImages());

    return {
        ACTION: httpResponse$
    }
}


export function requestSolicitorImages(sources) {
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.GET_SOLICITOR_IMAGES)
        .map(action => ({
            url: BASE_URL + 'api/agents/landingpage/images',
            category: 'solicitorHomeImages',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('solicitorHomeImages')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.receiveSolicitorImages(JSON.parse(response.text)));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function receivedFailedResponseSolicitorHomeImages(sources) {
    let httpResponse$ = sources.HTTP
        .select('solicitorHomeImages')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.failedToGetSolicitorImages(response));

    return {
        ACTION: httpResponse$
    };
}